module.exports = __webpack_public_path__ + "static/img/shan-shork.7dc21b27.png";